import React, { Component } from 'react';

import tryMe from '../../helpers/tryMe';
import BlueButton from '../Shared/BlueButton';

export class FormSubmit extends Component {
  render() {
    const { handleSubmit, handleMouseDown, entities, entityName } = this.props;
    var item = entities[entityName];

    const {
      title,
      style,
      disabled,
      variant,
      loading,
    } = this.props;

    var isFetching = !!(tryMe(item).isFetching) || !!loading;
    var isDisabled = !!(isFetching || disabled);

    var handleClick = function(e) {
      handleSubmit(e);
    };

    var handleMouseDownFn = handleMouseDown
      ? function(e) { handleMouseDown(e); }
      : function() {};

    return (
      <BlueButton
        label={title}
        style={style}
        onClick={handleClick}
        onMouseDown={handleMouseDownFn}
        loading={isFetching}
        disabled={isDisabled}
        variant={variant}
      />
    );
  }
}
